import {
  removeComp as removeCompAction,
  removeComps as removeCompsAction,
} from '../../redux/features/actions/removeComp.ts';
import { setCompSequence } from '../../redux/features/orderSlice.ts';
import {
  selectCompIndexById,
  selectCompSequence,
} from '../../redux/features/selectors/orderSelectors.ts';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.ts';

export const useCompActions = (propertyId: string) => {
  const dispatch = useAppDispatch();
  const compIndex = useAppSelector((state) => selectCompIndexById(state, propertyId));
  const compSequence = useAppSelector(selectCompSequence);

  const handleUpdateCompSequence = (newCompSequence: string[]) => {
    dispatch(setCompSequence(newCompSequence));
  };

  const moveComp = (currIndex: number, newIndex: number) => {
    if (currIndex >= compSequence.length || newIndex >= compSequence.length) {
      console.error('Invalid index');
      return;
    }

    // Copy the list
    const newCompSequence = [...compSequence];
    // Remove the item from the list
    const [removed] = newCompSequence.splice(currIndex, 1);
    // If the item was not in the list, throw an error
    if (removed === undefined) {
      console.error('Invalid index, comp not found');
      return;
    }
    // Insert it into the new position
    newCompSequence.splice(newIndex, 0, removed);

    handleUpdateCompSequence(newCompSequence);
  };

  const moveCompLeft = () => {
    if (compIndex !== undefined && compIndex > 0) {
      moveComp(compIndex, compIndex - 1);
    }
  };

  const moveCompRight = () => {
    if (compIndex !== undefined && compIndex < compSequence.length - 1) {
      moveComp(compIndex, compIndex + 1);
    }
  };

  const removeComp = (compId: string) => {
    const newCompSequence = compSequence.filter((id) => id !== compId);
    handleUpdateCompSequence(newCompSequence);
    dispatch(removeCompAction(compId));
  };

  const removeComps = (compIds: string[]) => {
    const newCompSequence = compSequence.filter((id) => !compIds.includes(id));
    handleUpdateCompSequence(newCompSequence);
    dispatch(removeCompsAction({ ids: compIds }));
  };

  return {
    moveCompLeft,
    moveCompRight,
    removeComp,
    removeComps,
  };
};
